<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    class="cn-icon"
    v-html="icons[name]"
  ></svg>
</template>

<script setup lang="ts">
import icons from './icons/icons';

export type Icon = keyof typeof icons;

interface Props {
  name: Icon;
}

defineProps<Props>();
</script>

<style>
.cn-icon {
  flex-shrink: 0;
}
</style>
